import { useState } from 'react';
export function useStorage(initialData, key = 'string', store = localStorage) {
    const [storage, _setStorage] = useState(() => {
        const fromStorage = store.getItem(key);
        return fromStorage ? JSON.parse(fromStorage) : initialData;
    });
    const setStorage = (newState) => {
        store.setItem(key, JSON.stringify(newState));
        _setStorage(newState);
    };
    return {
        storage,
        setStorage,
    };
}
